import { Utils } from './module/utils';

//-------------------------------------------
// DOMロードイベント
//-------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  Utils.switchViewport(376, 390);

  // アコーディオンクリック
  if (document.querySelector('.js-accordion .js-accordion-button')) {
    document.querySelectorAll('.js-accordion .js-accordion-button').forEach((el) => {
      el.addEventListener('click', (event) => {
        event.preventDefault();
        event.target.classList.toggle('is-open');
        jQuery(event.target).next().slideToggle(500);
      });
    });
  }
});

//-------------------------------------------
// Windowロードイベント
//-------------------------------------------
window.addEventListener('load', () => {});
